import { ValidBusinessObject } from '../../datastoreProxy'
import { MapLike } from '../../core'
import { IOTV_LCD_AS_DOWNLINK_RESPONSE, IOTV_LCD_DeviceMessage } from '../../Network/MessageTypes'
import { Networks } from '../../Network/NetworkTypes'
import { IOTV_SNSPublishInputToMessageAttributeMap, IOTV_SNS_PublishInput } from './SNS_base-types'
import { DeviceTypes, MessageAction } from '../../Network'

export enum DeviceControlMessageType {
  USER_REQUEST = 'USER_REQUEST',
  REJECTED_DUPLICATE_DOWNLINK = 'REJECTED_DUPLICATE_DOWNLINK',
  APPLICATION_SERVER_RESPONSE = 'APPLICATION_SERVER_RESPONSE',
  DEVICE_RESPONSE = 'DEVICE_RESPONSE',
  INGESTION = 'INGESTION',
}

export type IDeviceControlMessageAttributes<DCT extends DeviceControlMessageType> = {
  MessageType: DCT
  MessageAction?: MessageAction
  NetworkKey: string
  DeviceId: string
  TimestampMs: string
}

export interface IDeviceControlMessageObject<MessageT extends MapLike<any>, DCT extends DeviceControlMessageType> {
  MessageAttributes: IDeviceControlMessageAttributes<DCT>
  Message: MessageT
  TopicArn: string
}

export interface UserDeviceControlMessageObject<MessageT extends MapLike<any>>
  extends IDeviceControlMessageObject<MessageT, DeviceControlMessageType.USER_REQUEST> {}
export interface AppServerResponseControlMessageObject<MessageT extends MapLike<any>>
  extends IDeviceControlMessageObject<MessageT, DeviceControlMessageType.APPLICATION_SERVER_RESPONSE> {}
export interface DeviceResponseControlMessageObject<T extends MapLike<any>> extends IDeviceControlMessageObject<T, DeviceControlMessageType.DEVICE_RESPONSE> {}

export const getDeviceControlSNSInput = <MessageT extends MapLike<any>, DCT extends DeviceControlMessageType>(
  deviceControlMessageObject: IDeviceControlMessageObject<MessageT, DCT>,
) => {
  const publishInput: IOTV_SNS_PublishInput<IDeviceControlMessageAttributes<DCT>> = {
    ...deviceControlMessageObject,
    MessageAttributes: IOTV_SNSPublishInputToMessageAttributeMap(deviceControlMessageObject.MessageAttributes),
    Message: JSON.stringify(deviceControlMessageObject.Message),
  }
  return publishInput
}

/**
 * NetworkData -> DeviceControl
 */

/** Matches NetworkSystem/NetworkData/src/Processor/steps/9_emit/emissions/SQS_DeviceControl_NetworkData/deviceControl.ts */
export type DeviceControlMessageContent = {
  device: ValidBusinessObject & { deviceType?: DeviceTypes; deviceSubType?: string; firmwareLevel?: string }
  downlinkResponse: IOTV_LCD_AS_DOWNLINK_RESPONSE | undefined
  deviceMessage: IOTV_LCD_DeviceMessage | undefined
  reported: MapLike<any> | undefined
  entity: ValidBusinessObject | undefined
}

export type PublishToDeviceControlRequest = {
  DeviceId: string
  NetworkKey: Networks
  TimestampMs: string
  MessageGroupId: string
  messageObject: DeviceControlMessageContent
  MessageType: DeviceControlMessageType
  MessageAction: MessageAction | undefined
}

/**
 * DeviceContorl <- NetworkData
 * */

export type DeviceControlRequest = PublishToDeviceControlRequest
